export default import.meta.ROLLDOWN_FILE_URL_d8eBOsBzDDx4DxnC9kxu_w